module.exports = __webpack_public_path__ + "files/0edc85a21e9162ebb7c0bff073008091.png";